<template>
  <div>
    <h1 class="text-center">Booking Calendar</h1>
    <div>
      <CalendarFilter />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CalendarFilter from "./CalendarFilter.vue";

export default Vue.extend({
  components: {
    CalendarFilter,
  },
  mounted() {
    const targetElement = document.querySelector(".container");
    if (targetElement) targetElement.classList.add("container-fullwidth"); // Adds 'new-class'
  },
});
</script>

<style>
.container-fullwidth {
  max-width: unset !important;
}
</style>